import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Get active units for dropdown using existing API structure
export const getActiveUnits = async () => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Unit/get`, {
      unit_Id: null,
      unit_Code: "",
      unit_NameEn: "",
      unit_NameAr: "",
      unit_Active: true, // Only get active units
      unit_CreatedDate: null,
      unit_CreatedBy: null,
      unit_ModifiedDate: null,
      unit_ModifiedBy: null
    }, {
      headers: getAuthHeader(),
    });
    
    // Transform the response to match the expected format for the dropdown
    const units = response.data || [];
    return units.map(unit => ({
      value: unit.unit_Id,
      label: `${unit.unit_Code} - ${unit.unit_NameEn}`
    }));
  } catch (error) {
    console.error("Error fetching active units:", error);
    throw error;
  }
};
